import useSortStore from "../store/useSortStore";
import { lotsStore } from "../store/useLotsStore";
import { LotsSortBy, SortDirection } from "../types/filterAndSort";
export function attachSortStateListener() {
    const detachListeners = useSortStore.subscribe((state) => {
        sortFilteredLots(state.sortBy, state.sortDirection);
    });
    return detachListeners;
}
export function sortFilteredLots(sortBy, sortDirection) {
    // Sort the lots depending on the sortBy and sortDirection states
    const sortedFilteredLots = lotsStore.getState().filteredLots.sort((a, b) => {
        if (sortBy === LotsSortBy.Price) {
            const aPrice = a.Properties.Price ?? Infinity;
            const bPrice = b.Properties.Price ?? Infinity;
            if (sortDirection === SortDirection.Ascending) {
                return aPrice - bPrice;
            }
            else if (sortDirection === SortDirection.Descending) {
                return bPrice - aPrice;
            }
        }
        else if (sortBy === LotsSortBy.DateAdded) {
            const aDate = new Date(a.Properties.ModifiedDate ?? '');
            const bDate = new Date(b.Properties.ModifiedDate ?? '');
            const aDateMilliSecs = aDate.getTime();
            const bDateMilliSecs = bDate.getTime();
            if (sortDirection === SortDirection.Ascending) {
                return aDateMilliSecs - bDateMilliSecs;
            }
            else if (sortDirection === SortDirection.Descending) {
                return bDateMilliSecs - aDateMilliSecs;
            }
        }
        return 0;
    });
    lotsStore.getState().setFilteredLots(sortedFilteredLots);
}
